import Namer from '../Generic/Namer';

export default Namer(
    'units',
    x => {
        return typeof x === 'undefined' ?
            'unknown unit' :
            x.name || x.typedId.split(':')[1];

    },
    (v, i) => 
        typeof i !== 'undefined' &&
        typeof i.typedId !== 'undefined' &&
        typeof v !== 'undefined' &&
        i.typedId.substring(0, v.length) === v
);


// WEBPACK FOOTER //
// ./src/container/Unit/UnitName.tsx